<script setup lang="ts">
import {
  ClassSelector,
  CounterTheme,
  CounterType
} from "~/components/Molecules/Counter.props"
import { SeparatorProps } from "./Separator.props"
import { DigitSize } from "./Digit.props"
import { getClass } from "~/components/Molecules/Counter.util"

withDefaults(defineProps<SeparatorProps>(), {
  separator: ":",
  theme: CounterTheme.squared,
  type: CounterType.complete,
  digitSize: DigitSize["2xl"]
})
</script>
<template>
  <span :class="[...getClass(digitSize, ClassSelector.separatorClass)]">
    {{ separator }}
  </span>
</template>
<style lang="scss" module></style>
